import './App.css';
import "@fontsource/montserrat";
import Navbar from "./Components/Navbar/index";
import Intro from "./Components/Intro";
import Technologies from "./Components/Technologies";
import Experience from "./Components/Experience";
import Projects from "./Components/Projects";
import Education from "./Components/Education";
import Contact from "./Components/Contact";

function App() {
  return (
    <div className="App">
        <Navbar/>
        <Intro/>
        <Technologies/>
        <Experience/>
        <Projects/>
        <Education/>
        <Contact/>
    </div>
  );
}

export default App;
